import { Cable } from '@rails/actioncable';
import React, { useContext } from 'react';

export const CableContext = React.createContext<Cable | null>(null);

export const useCable = () => {
  const cable = useContext(CableContext);

  if (cable == null) {
    throw new Error('useCable must be used inside a CableContext provider');
  }

  return cable;
};
